
<script>
const name = 'MvTabs'

export default {
  name,
  emits: ['tabs'],
  components: { },

  props: {
    tabsHeaders: {
      type: [],
      default: [{title: '', icon: ''}]
    }
  },

  mounted () { },

  updated () { },

  data () {
    return {
      tabs: 0
    }
  },

  methods: { },

  watch: {
    tabs (newValue) {
      this.$emit('tabs', newValue)
    }
  },
  computed: { }

}
</script>

<template>
    <div class="d-flex">
        <div class="d-flex" v-for="(header,index) in tabsHeaders" :key="index" >
            <div style="left-container">
            <slot v-if=" index === tabs " :name="`leftContainer${index}`"></slot>
            </div>
        </div>
        <div class="col-md-9">
            <b-tabs v-model="tabs">
                <b-tab :title="header.title" v-for="(header,index) in tabsHeaders" :key="index">
                <template  slot="title">
                    <i class="text-third" :class="header.icon"></i>
                    <span class="d-md-down-none pl-1 text-third" >
                    {{header.title}}
                    </span>
                </template>
                <slot :name="`tab${index}`"></slot>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/private/reports/consultstatus/components/MvTabs/MvTabs.vue